// extracted by mini-css-extract-plugin
module.exports = {"page":"Connect_page__1-5oI","connect":"Connect_connect__3uVl4","detail":"Connect_detail__2TRCH","screen":"Connect_screen__2eY-u"};